import React from 'react'
import { withRouter } from 'react-router-dom'
import { mssgs } from '../../../constantes/mssgs'
import NullMssg from '../../common/NullMssg'
import ProductPresentationCard from './ProductPresentationCard'

const ProductsPresentationList = (
    {
        isEditPresentation,
        allPresentationProducts,
        goToViewDetailProduct,
        handleRemovePresentationProduct,
        toEditPresentationProduct
    }
) => {
    
    return (
        <>
            { 
                allPresentationProducts.length > 0 ? allPresentationProducts.map((product, i) => 
                    <div className="products__cards-list" key={i}>
                        <div className="products__table">
                        <div className="card__horizontal mb-30">
                                {
                                    product.isActivo ?
                                        <h4 className="products__sub">{product.nombreArticulo}</h4>
                                    :   <h4 className="products__sub" style={{color: "#0ca39e96"}}>{product.name}</h4>
                                }
                                {
                                    isEditPresentation ?
                                        <h4 className="products__sub" style={{ justifyContent: 'flex-end'}}>Acciones</h4>
                                    : null
                                }
                            </div>
                            <ProductPresentationCard
                                product={product}
                                isEditPresentation={isEditPresentation}
                                goToViewDetailProduct={goToViewDetailProduct}
                                handleRemovePresentationProduct={handleRemovePresentationProduct}
                                toEditPresentationProduct={toEditPresentationProduct}
                            />
                        </div>
                    </div>
                ) :  
                <table style={{width: "100%"}}> 
                    <tbody><NullMssg mssg={mssgs.NADA_QUE_MOSTRAR_AÑADIR_PRODUCTOS_PRESENTACION}/></tbody>
                </table>
            }
        </>
    )
}

export default withRouter(ProductsPresentationList)